/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './requestEmailUpdate.defs.js'
export { main as default } from './requestEmailUpdate.defs.js'
